export default function HWY_Header() {
  this.init = () => {
    if (jQuery(".main-menu-mobile-body .menu-main-menu li").length) {
      jQuery(".main-menu-mobile-body .menu-main-menu li").each(function () {
        const el = jQuery(this);
        el.find(".sub-menu").slideUp(400);
      });
    }
    jQuery(".main-menu-mobile-header-right-close").click(function () {
      jQuery("body").css("overflow-y", "auto");
      jQuery(".main-menu-mobile").removeClass("active");
      jQuery(".main-menu-mobile").css({
        "padding-top": 0,
      });
    });
    jQuery(".icon-toggle").click(function () {
      jQuery(this)
        .closest(".main-menu-mobile-body .menu-main-menu li")
        .siblings()
        .each(function () {
          if (jQuery(this).find(".icon-toggle").hasClass("open")) {
            jQuery(this).find(".sub-menu").slideUp(400);
            jQuery(this).find(".icon-toggle").toggleClass("open");
          }
        });
      if (jQuery(this).hasClass("open")) {
        jQuery(this).toggleClass("open");
        jQuery(this)
          .closest(".menu-main-menu li")
          .find(".sub-menu")
          .slideUp(400);
        return;
      }
      jQuery(this).toggleClass("open");
      jQuery(this)
        .closest(".menu-main-menu li")
        .find(".sub-menu")
        .slideDown(400);
    });
    addWidget();
  };
  const openMenu = () => {
    jQuery("body").css("overflow-y", "hidden");
    const height = jQuery(".announcement_bar").outerHeight();
    jQuery(".main-menu-mobile").addClass("active");
    jQuery(".main-menu-mobile").css({
      "padding-top": height,
    });
  };
  const addWidget = () => {
    if (jQuery(window).width() < 800) {
      jQuery(".header .header-top .header-right").append(`
    <span class="view-cart" href="#">
        <div id="c7-cart"></div>
    </span>
    <div class="mobile-hamburger">
        <input class="menu-btn" type="checkbox" id="menu-btn" />
        <label class="menu-icon" for="menu-btn"><span class="navicon"></span></label>
    </div>`);
      jQuery(".main-menu-mobile .main-menu").append(
        `<div id="c7-account"></div>`
      );
    } else {
      jQuery(".header .header-top .header-right").append(`
    <div id="c7-account"></div>
    <span class="view-cart" href="#">
        <div id="c7-cart"></div>
    </span>
    <div class="mobile-hamburger">
        <input class="menu-btn" type="checkbox" id="menu-btn" />
        <label class="menu-icon" for="menu-btn"><span class="navicon"></span></label>
    </div>`);
    }
    jQuery(".mobile-hamburger").click(function () {
      openMenu();
    });
  };
}
